import { UiVideoPlayerModel } from "../../models";

export function mockUiVideoPlayerModel({
    id = "video-1234",
    type = "uiVideoPlayer",
    locale = "en",
    content = mockUiVideoPlayerModelContent()
}: Partial<UiVideoPlayerModel> = {}): UiVideoPlayerModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiVideoPlayerModelContent = UiVideoPlayerModel["content"];

export function mockUiVideoPlayerModelContent({
    videoProvider = "Wistia",
    videoId = "1z7vnaokt6",
    title = "Example Loom video"
}: Partial<UiVideoPlayerModelContent> = {}): UiVideoPlayerModelContent {
    return {
        videoProvider,
        videoId,
        title
    };
}
